import { useState } from 'react'
import clsx from 'clsx'

interface Props {
  display: string
  type: 'email' | 'password' | 'text'
  name: string
  value?: string
  min: number
  max: number
  showLimit?: boolean
  inputErrorFlag?: boolean
}

const Input: React.FC<Props> = ({
  display,
  type,
  name,
  value,
  min,
  max,
  showLimit = true,
  inputErrorFlag,
}) => {
  const [focused, setFocused] = useState(value ? true : false)
  const [textValues, setTextValues] = useState({
    count: value ? value.length : 0,
    min: min,
    max: max,
    value: value || '',
  })

  return (
    <div className="mb-[15px] flex w-full items-center justify-center select-none">
      <div
        className={clsx(
          'bgd-theme relative flex w-full flex-col justify-center rounded-[5px] border border-solid',
          {
            'border-blue': focused,
            'border-theme': !focused,
            'border-red': inputErrorFlag,
          },
        )}
      >
        <div
          className={clsx('flex h-[15px] justify-end text-xl font-medium', {
            'text-blue': focused,
            'text-inherit': !focused,
            'text-red': inputErrorFlag,
          })}
        >
          <p
            className={clsx('pt-[5px] pr-[10px] text-sm font-light opacity-0', {
              'opacity-100': focused,
            })}
          >
            {showLimit ? `${textValues.count}/${textValues.max}` : ' '}
          </p>
        </div>
        <input
          type={type}
          name={name}
          minLength={min}
          maxLength={max}
          onFocus={() => {
            setFocused(true)
          }}
          onBlur={() => {
            if (!textValues.value) {
              setFocused(false)
            }
          }}
          onChange={(e) => {
            setTextValues((curr) => {
              return {
                ...curr,
                value: e.target.value,
                count: e.target.value.length,
              }
            })
            // below is for removing red error outline/border once requirements are met on every text value onChange
            // if(inputErrorFlag) {
            //   if(textValues.count > textValues.min) {}
            // }
          }}
          className="z-[100] h-[50px] rounded-[5px] bg-transparent p-0 px-[10px] text-lg text-inherit"
          value={textValues.value}
        />
        <div
          className={clsx(
            'absolute bottom-[20px] left-0 px-[10px] font-medium transition-all duration-300',
            {
              'text-blue translate-y-[-100%] text-sm': focused,
              'text-sub text-xl': !focused,
              'text-red': inputErrorFlag,
            },
          )}
        >
          <p>{display}</p>
        </div>
      </div>
    </div>
  )
}

export default Input
